var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveBannerIconPrompt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1113,
    y: 15.1094,
    width: 3.55556,
    height: 9.77778,
    stroke: "#8C8C8C",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.334,
    y: 15.1094,
    width: 3.55556,
    height: 9.77778,
    stroke: "#8C8C8C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3055 29.8054H29.8055V30.3054V34.2771C29.8055 38.1958 34.591 40.2785 37.4338 37.4342C40.2786 34.5913 38.1958 29.8054 34.2771 29.8054H30.3055ZM9.69431 29.0574H10.1943V28.5574V11.4415V10.9415H9.69431H5.72276C1.12518 10.9415 -1.26346 5.33527 2.03701 2.03599L2.03708 2.03592C5.33607 -1.26317 10.9423 1.12407 10.9423 5.72351V9.69519V10.1952H11.4423H28.5577H29.0577V9.69519V5.72351C29.0577 1.12415 34.6636 -1.26303 37.9629 2.03584C41.2622 5.3369 38.8745 10.9415 34.2773 10.9415H30.3057H29.8057V11.4415V28.5574V29.0574H30.3057H34.2773C38.8765 29.0574 41.2636 34.6634 37.963 37.9628L37.963 37.9629C34.6638 41.2621 29.0577 38.8746 29.0577 34.2771V30.3054V29.8054H28.5577H11.4423H10.9423V30.3054V34.2771C10.9423 38.8765 5.33639 41.2636 2.03715 37.963L2.03699 37.9628C-1.26363 34.6637 1.12358 29.0574 5.72276 29.0574H9.69431ZM10.1925 30.3051L9.7005 30.3053L9.70669 29.8055L9.70491 29.8055L9.19231 29.7928L9.19232 29.8054H5.72276C1.80399 29.8054 -0.278587 34.5913 2.56596 37.4341C5.40885 40.2787 10.1943 38.1957 10.1943 34.277V34.2768L10.1925 30.3051ZM9.69431 10.1935H10.1943V9.69354V5.72187C10.1943 1.80115 5.40866 -0.279402 2.56601 2.56476C2.56597 2.5648 2.56593 2.56484 2.56589 2.56488C2.56585 2.56492 2.56581 2.56495 2.56578 2.56499C-0.278465 5.40774 1.80211 10.1935 5.72276 10.1935H9.69431ZM29.8053 9.69354L29.8053 10.1935H30.3053H34.2769C38.1956 10.1935 40.2782 5.40764 37.4337 2.56481C34.5908 -0.279743 29.8054 1.80325 29.8054 5.72191L29.8053 9.69354ZM29.0573 11.4416V10.9416H28.5573H11.442H10.942V11.4416V28.5574V29.0574H11.442H28.5573H29.0573V28.5574V11.4416Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveBannerIconPrompt);
export default __webpack_public_path__ + "static/media/inactiveBannerIconPrompt.beda1cb138f7fb8161247784cfc28ae0.svg";
export { ForwardRef as ReactComponent };